import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Question } from '../../models/underwriter.model';
import { SidesheetComponent } from '../../components/sidesheet/sidesheet.component';
import { FlowPlayerService } from '../../services/flow-player.service';
import { GlobalQuestionService } from '../../services/global-question.service';
import { MiniQuestionQuery } from '../state/mini-question.query';
import { QuestionFlowSessionQuery } from '../state/question-flow-session.query';


@Component({
    selector: 'app-question-mini-flow-sidesheet',
    templateUrl: './question-mini-flow-sidesheet.component.html',
    styleUrls: ['./question-mini-flow-sidesheet.component.scss'],
    standalone: false
})
export class QuestionMiniFlowSidesheetComponent implements OnInit, OnChanges {

  @ViewChild('itemSidesheet') itemSidesheet: SidesheetComponent;

  @Input() question: Question;
  @Input() readOnly = false;
  @Output() questionAnswer = new EventEmitter<Question>();

  items: any[] = [];
  editingIndex = -1;
  editingItemId: any = null;
  currentItem: any;
  flowQuestions: Question[] = [];
  session_details: any;
  isLoading = false;
  emptyState: any;
  item_id = 0;
  side_sheet_title = '';
  constructor(
    private flowPlayer: FlowPlayerService,
    public questionService: GlobalQuestionService,
    private sessionQuery: QuestionFlowSessionQuery
  ) {}

  ngOnInit(): void {
    this.session_details = this.sessionQuery.getValue();
    this.getMiniFlowSideSheet();
     this.questionService.getChildrenQuestions(this.question?.cent_aq_question_id)
      .subscribe((items: Question[]) => {
        this.flowQuestions = items.map(q => ({ ...q, answer: '' }));
      });
  }

  getMiniFlowSideSheet(): void {
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.session_details?.session_id);
    parameters.set('question_id', this.question?.cent_aq_question_id?.toString());
    parameters.set('flow_id', this.question?.flow_id?.toString());
    parameters.set('class_id', this.question?.product_class_id?.toString());
    parameters.set('item_id', this.question?.item_id?.toString());
    parameters.set('product_group_id', this.session_details?.group_id?.toString());

    this.isLoading = true;
    this.questionService.runCommandNew('getMiniFlowSideSheet', parameters).subscribe(data => {
      this.emptyState = data.find(i => i.entry_type === 'empty_state');
      this.side_sheet_title = data.find(i => i.entry_type === 'side_sheet_title')?.side_sheet_title || '';
      if (this.emptyState?.empty_state && typeof this.emptyState.empty_state === 'string') {
        try { this.emptyState.empty_state = JSON.parse(this.emptyState.empty_state); } catch { }
      }
      else {
        this.items = data.filter((i: any) => i.entry_type !== 'side_sheet_title') ?? [];
      }
      this.item_id = this.items.reduce((maxId, item) => Math.max(maxId, item.item_id || 0), 0);
      this.isLoading = false;
      if (this.items.length > 0) {
        this.question.answer = JSON.stringify(this.items);
        this.questionAnswer.emit(this.question);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes.question.currentValue;
      try {
        this.items = JSON.parse(this.question?.answer) ?? [];
      } catch {
        this.items = [];
      }
    }
  }

  private emptyItem(): any {
    this.item_id += 1;
    this.flowQuestions = this.flowQuestions.map(q => ({ ...q, answer: '', item_id: this.item_id.toString() }));
    return this.flowQuestions;
  }

  onBackClicked(): void {
    this.editingIndex = -1;
    this.currentItem = this.emptyItem();
  }

  openSidesheet(index: number = -1): void {
    this.editingIndex = index;
    if (index > -1) {
      const existingItem = this.items[index];
      this.editingItemId = existingItem?.item_id ?? null;
      if (existingItem?.responses) {
        try {
          const responses: { cent_aq_question_id: number; cent_answer_data: string }[] =
            typeof existingItem.responses === 'string'
              ? JSON.parse(existingItem.responses)
              : existingItem.responses;
          this.flowQuestions = this.flowQuestions.map(q => {
            const match = responses.find(r => r.cent_aq_question_id === q.cent_aq_question_id);
            return match
              ? { ...q, answer: match.cent_answer_data, item_id: this.editingItemId?.toString() }
              : { ...q, answer: '', item_id: this.editingItemId?.toString() };
          });
        } catch {}
      }
    } else {
      this.editingItemId = null;
      this.emptyItem();
    }
    this.currentItem = this.flowQuestions;
    this.itemSidesheet.open();
  }

  onItemSaved(_event: any): void {
    this.editingIndex = -1;
    this.emitAnswer();
  }

  deleteItem(index: number): void {
    let itemToDelete = this.items[index];
    console.log(itemToDelete);

    const parameters = new Map<string, string>();
    parameters.set('session_id', this.session_details?.session_id);
    parameters.set('class_id', this.question?.product_class_id?.toString());
    parameters.set('item_id', itemToDelete?.item_id?.toString());
    parameters.set('location_id', this.question?.location_id?.toString() ?? '0');
    this.questionService.runCommandNew('removeClassItem', parameters).subscribe( {
      next: (data) => {        
        this.getMiniFlowSideSheet();
      }
    });

    
  }

  private emitAnswer(): void {
    this.question.answer = JSON.stringify(this.items);
    this.questionAnswer.emit(this.question);

    const parameters = new Map<string, string>();
    parameters.set('session_id', this.session_details?.session_id);
    parameters.set('category_id', this.session_details?.category_id);
    parameters.set('group_id', this.session_details?.group_id);
    parameters.set('class_id', this.question?.product_class_id?.toString());
    parameters.set('vaps_id', this.question?.vaps_id?.toString() ?? '0');
    parameters.set('item_id', (this.editingItemId ?? this.item_id)?.toString());
    parameters.set('location_id', this.question?.location_id?.toString() ?? '0');
    parameters.set('flow_id', this.question?.flow_id?.toString());
    parameters.set('side_sheet_question_id', this.question?.cent_aq_question_id?.toString());
    this.questionService.runCommandNew('setMiniFlowSideSheetComplete', parameters).subscribe( {
        next: (data) => {
          this.editingItemId = null;
          this.currentItem = this.emptyItem();
          this.getMiniFlowSideSheet();
        }
      });


    
  }
}
